import(/* webpackMode: "eager" */ "/src/app/error.tsx")